import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarNotificationService } from '../snackbar-notification.service';

export class SnackbarWithDetailsButtonData {
    queueItemId!: string;
    message!: string;

    constructor(init: SnackbarWithDetailsButtonData) {
        Object.assign(this, init);
    }
}

@Component({
    selector: 'rax-snackbar-with-details-button',
    templateUrl: './snackbar-with-details-button.component.html',
    styles: [
        `
            :host {
                display: flex;
            }

            .mdc-snackbar__label {
                padding: 0;
            }
        `,
    ],
    imports: [MatButton, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction],
})
export class SnackbarWithDetailsButtonComponent {
    private snackbarData: SnackbarWithDetailsButtonData = inject(MAT_SNACK_BAR_DATA);
    private snackBarRef = inject(MatSnackBarRef);
    private notificationService = inject(SnackbarNotificationService);

    public message: string = this.snackbarData.message;

    public onDetailsButtonClick(): void {
        this.notificationService.notificationActionTriggered.next({
            queueItemId: this.snackbarData.queueItemId,
        });
    }

    public onCloseSnackbarButtonClick(): void {
        this.snackBarRef.dismiss();
    }
}
